// src/components/TontineCard.jsx — summary card for a tontine, used on Dashboard/Browse
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight, Users } from "lucide-react";

const TontineCard = ({ tontine, displayName }) => {
  const { t } = useTranslation();

  const status = tontine.status === "active" ? "active" : tontine.status === "forming" ? "forming" : "paused";
  const statusClasses = status === "active"
    ? "bg-emerald-50 text-emerald-700"
    : status === "forming"
      ? "bg-amber-50 text-amber-800"
      : "bg-gray-100 text-gray-600";

  return (
    <Link
      to={`/tontines/${tontine._id}`}
      className="card group block overflow-hidden p-5"
    >
      <div className="mb-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-gold-700">{t(`tontine.categories.${tontine.category}`)}</p>
          <h3 className="mt-2 font-serif text-xl font-semibold text-gray-900 transition-colors group-hover:text-gold-700">{displayName || tontine.name}</h3>
        </div>
        <span className={`rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] ${statusClasses}`}>
          {t(`tontine.statuses.${status}`)}
        </span>
      </div>

      <div className="mb-5 rounded-xl bg-gold-50 p-3">
        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-gray-500">{t("tontine.contribution")}</p>
        <p className="mt-2 text-lg font-bold text-forest">
          {tontine.amount} {tontine.currency?.toUpperCase() || "EUR"}
        </p>
      </div>

      <p className="mb-5 line-clamp-2 text-sm leading-6 text-gray-500">
        {tontine.description || "A trusted community savings circle."}
      </p>

      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-gray-100 pt-4 text-sm text-gray-600">
        <span className="inline-flex items-center gap-1.5">
          <Users size={14} className="text-gold-600" />
          {tontine.members?.length || 0}/{tontine.maxMembers}
        </span>
      </div>

      <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-gold-600">
        {t("tontine.viewCircle")} <ArrowUpRight size={13} />
      </span>
    </Link>
  );
};

export default TontineCard;
